import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';
import { UserCardType } from '~/types/paymentTypes';

export default function PaymentDetails({ card }: { card: UserCardType }) {
  const { t } = useTranslation('app');
  const { MY_ACCOUNT_URL } = useFullRoutes();

  return (
    <div className="flex flex-col gap-1.5x border-t border-gray pt-2x px-3x">
      <div className="flex justify-between">
        <p className="text-title_4"> {t('paymentDetails')}</p>
        <Link
          to={MY_ACCOUNT_URL.USER_CARDS.ROOT}
          className="text-link text-blue "
        >
          <Icon name="edit" className="text-blue" />
        </Link>
      </div>
      <div className="flex gap-1.5x">
        <div className="flex element-center">
          <i
            className={`inline-block bg-cover w-[32px] h-[24px] ${card.card_brand.toLowerCase()}-icon `}
          />
        </div>
        <p className="text-body_1 text-gray__dark_1">{`XXXX-${card.card_last4}`}</p>
      </div>
    </div>
  );
}
